import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import {
    setLeader as setLeaderLocal,
    setIsLeader,
    setIsChangingLeader,
    setNewLeaderAttributes,
    setLeaderHistory,
    getPlayers,
    getLeader,
    getNewLeaderAttributes,
    isLeader,
    isChangingLeader,
    getLeaderHistory,
} from "@bd-stores/game-progress";
import { dispatch, store } from "@bd-stores/store";
import {
    setChangingLeaderAttributes,
    setLeader,
    addLeaderHistory,
    setIsLeaderChanged,
    deleteChangingLeaderAttributes,
} from "@bd-core/firebase-actions";
import { getCurrentPageId } from "@bd-stores/user-progress";
import { isTestMode } from "@bd-utils/test-mode";

export const SwitchLeader = () => {
    let changeLeaderTimeout = null;
    let globalPlayers = null;

    function init() {
        registerEvents();
    }

    function registerEvents() {
        $(document).on(
            "click",
            "#btn-switch-leader",
            renderSwitchLeaderElement,
        );
        $(document).on("click", ".leader-switch__list", onSelectNewLeader);
        $(document).on("click", ".js-leader-indicator", onProceedNewLeader);
        bdjs.listen("bd__teamAttributeChanged", onTeamAttributeChange);
        bdjs.listen("bd__onOpenLeaderSwitch", openLeaderSwitch);
        bdjs.listen("bd__playersStateChanged", onPlayerStateChanged);
    }

    function onPlayerStateChanged(e, eventData) {
        const players = eventData.data;
        globalPlayers = players;
        const userId = CONFIG.user.id;
        const currentPlayer = players.find((p) => p.userId === userId);

        // handle offline players
        if (!currentPlayer.isOnline) {
            showSnackbarMessage(window.CFG?.strings.playerDisconnected);
        }

        // change leader after 30s leader disconnected

        const currentLeaderId = getLeader();
        if (currentLeaderId !== 0) {
            const currentLeader = players.find(
                (p) => p.userId == currentLeaderId,
            );
            if (currentLeader && !currentLeader.isOnline) {
                if (changeLeaderTimeout) {
                    console.warn(
                        "Clear change leader timeout : ",
                        changeLeaderTimeout,
                    );
                    clearTimeout(changeLeaderTimeout);
                }

                console.warn("Current leader goes offline, make 30s timeout.");

                changeLeaderTimeout = setTimeout(function () {
                    const oldLeader = globalPlayers?.find(
                        (p) => p.userId == currentLeaderId,
                    );

                    if (oldLeader && !oldLeader.isOnline) {
                        const onlinePlayers = globalPlayers?.filter(
                            (p) => p.isOnline,
                        );

                        if (onlinePlayers?.[0].userId == userId) {
                            setLeader(userId);
                            addLeaderHistory(userId);
                            showSnackbarMessage(
                                window.CFG?.strings.leaderOffline,
                            );

                            setTimeout(function () {
                                window.location.reload();
                            }, 5000);
                        }
                    } else {
                        console.warn(
                            "Cancel request change leader, current leader back to online",
                        );
                    }
                }, 30000);
            }
        }
    }

    function onTeamAttributeChange(e, eventData) {
        const data = eventData.data;
        const isLeader = CONFIG.user.id === data.leader;
        store.dispatch(setIsLeader(isLeader));
        store.dispatch(setLeaderLocal(data.leader));

        if (data.newLeaderAttributes) {
            if (!data.newLeaderAttributes.isConfirmed) {
                store.dispatch(setIsChangingLeader(true));
                store.dispatch(
                    setNewLeaderAttributes(data.newLeaderAttributes),
                );
                renderChangingLeader(data.newLeaderAttributes);
            } else {
                store.dispatch(setIsChangingLeader(false));
                store.dispatch(
                    setNewLeaderAttributes({ newLeader: 0, isConfirmed: true }),
                );
                onConfirmedChange();
            }
        }

        if (data.leaderHistory) {
            const history = Object.values(data.leaderHistory).map(function (l) {
                return l;
            });

            dispatch(setLeaderHistory(history));
        } else {
            // set leader history for the first time
            if (isLeader) {
                addLeaderHistory(data.leader);
            }
        }
    }

    function onSelectNewLeader() {
        const isCurrentLeader = isLeader();
        const isChanging = isChangingLeader();

        if (!isCurrentLeader || isChanging) {
            return;
        }

        const $this = $(this);
        const playerId = $this.attr("player-id");
        const playerIndex = $this.attr("player-index");

        if (
            parseInt(playerId) === CONFIG.user.id ||
            $this.hasClass("is-not-candidate")
        ) {
            return;
        }

        $(".leader-switch__list")
            .not(".is-not-candidate")
            .removeClass("is-selected");
        $this.addClass("is-selected");
        const $wrapper = $(".leader-switch__container");
        $wrapper.find(".js-leader-indicator").remove();

        $wrapper.append(`
        <div class="leader-switch__indicator js-leader-indicator" style="transform: translateX(${
            parseInt(playerIndex) * 100
        }%);" data-action="proceed" player-id="${playerId}">
            <div class="leader-switch__indicator-text">Select this player as new leader</div>
            <button class="leader-switch__indicator-action is-active js-switch-leader-button active">Proceed</button>
        </div>
        `);
    }

    function onProceedNewLeader() {
        const $this = $(this);
        const action = $this.attr("data-action");
        const playerId = $this.attr("player-id");

        if (action === "proceed") {
            const isCurrentLeader = isLeader();
            const isChanging = isChangingLeader();
            if (!isCurrentLeader || isChanging) {
                return;
            }

            setChangingLeaderAttributes({
                newLeader: parseInt(playerId),
                isConfirmed: false,
            });
        } else if (action === "confirm") {
            const newLeaderAttributes = getNewLeaderAttributes();
            if (newLeaderAttributes.newLeader === CONFIG.user.id) {
                setChangingLeaderAttributes({ isConfirmed: true });
                setLeader(newLeaderAttributes.newLeader);
                addLeaderHistory(newLeaderAttributes.newLeader);
            }
        }
    }

    function onConfirmedChange() {
        const $wrapper = $(".js-leader-switch");
        $wrapper.find(".js-leader-indicator").remove();
        $wrapper.removeClass("active");

        const roomId = getCurrentPageId();
        setIsLeaderChanged(roomId, true);
        deleteChangingLeaderAttributes();
    }

    function openLeaderSwitch() {
        const $wrapper = $(".js-leader-switch");
        if ($wrapper.hasClass("active")) {
            return;
        }

        renderSwitchLeaderElement();
    }

    function renderSwitchLeaderElement() {
        const players = getPlayers();
        const onlinePlayers = players.filter((p) => p.isOnline);

        if (!onlinePlayers || !onlinePlayers.length) {
            return;
        }

        const $switch = $(".js-leader-switch");

        // prevent open change leader pop up on single player or test mode
        if (onlinePlayers.length < 2 || isTestMode()) {
            $switch.removeClass("active");
            return;
        }

        renderPlayerList(onlinePlayers);

        const isOpen = $switch.hasClass("active");
        $switch.toggleClass("active");
        const isChanging = isChangingLeader();
        if (isChanging) {
            renderChangingLeader(getNewLeaderAttributes(), isOpen);
        }
    }

    function renderChangingLeader(data, isOpen = false) {
        const isChanging = isChangingLeader();
        if (!isChanging) {
            return;
        }

        let $selected = $(`.leader-switch__list[player-id=${data.newLeader}]`);
        let playerIndex = $selected.attr("player-index");
        let isMe = data.newLeader === CONFIG.user.id;

        const $switchWrapper = $(".js-leader-switch");
        if (isMe && !isOpen) {
            const players = getPlayers();
            const onlinePlayers = players.filter(
                (p) => p.isOnline || p.userId === CONFIG.user.id,
            );

            renderPlayerList(onlinePlayers);
            $switchWrapper.addClass("active");
            if (!$selected.length) {
                $selected = $(
                    `.leader-switch__list[player-id=${data.newLeader}]`,
                );
                playerIndex = $selected.attr("player-index");
            }
        }

        // $(".leader-switch__list").removeClass("is-selected");
        $(`.leader-switch__list[player-id=${data.newLeader}]`).addClass(
            "is-selected",
        );
        renderConfirmButton(data.newLeader, playerIndex, isMe);
    }

    function renderPlayerList(players) {
        const isCurrentLeader = isLeader();
        const leader = getLeader();

        const history = getLeaderHistory();
        const modulo = history.length % players.length;
        const currentLoop = history.slice(
            history.length - modulo,
            history.length,
        );

        const leaderCandidates = players.filter(
            // @ts-ignore
            (p) => !currentLoop.includes(p.userId),
        );

        let $playerList = "";
        players.map((player, i) => {
            const isMe = isCurrentLeader && player.userId === CONFIG.user.id;
            const isCandidate = leaderCandidates.find(
                (candidate) => candidate.userId === player.userId,
            );
            const isLeader = player.userId === leader;

            const isMeClass = isMe ? "is-me is-not-candidate" : "";
            const isCandidateClass =
                (isLeader && !isMe) || !isCandidate
                    ? "is-selected is-not-candidate"
                    : "";

            $playerList += `
            <div class="leader-switch__list ${isMeClass} ${isCandidateClass}" player-id="${player.userId}" player-index="${i}">
                <div class="leader-switch__avatar" style="background-image: url(${player.avatarURL});"></div>
                <div class="leader-switch__name">${player.name}</div>
            </div>
            `;
        });

        $(".leader-switch__lists").html($playerList);
    }

    function renderConfirmButton(playerId, playerIndex, isMe) {
        const $wrapper = $(".leader-switch__container");
        $wrapper.find(".js-leader-indicator").remove();

        $wrapper.append(`
        <div class="leader-switch__indicator js-leader-indicator" style="transform: translateX(${
            parseInt(playerIndex) * 100
        }%);" data-action="confirm" player-id="${playerId}">
            <div class="leader-switch__indicator-text">${
                isMe
                    ? "You are the new team leader"
                    : "This is your new team leader"
            }</div>
            <button class="leader-switch__indicator-action is-active js-switch-leader-button ${
                isMe ? "active" : ""
            }">${isMe ? "Confirm" : "Waiting for confirmation"}</button>
        </div>
        `);
    }

    const showSnackbarMessage = (text) => {
        const $snackbar = $(".snackbar");
        if (!$snackbar.length) {
            alert(text);
            return;
        }

        const $overlay = $(".general-overlay");

        $snackbar.find(".snackbar__body").html(text);
        $snackbar.addClass("is-active");
        $overlay.addClass("is-active");
    };

    init();
};
